import { Children, cloneElement, isValidElement, useCallback, useMemo } from 'react';

const normalizeTabIndex = (tabIndex) => {
    return tabIndex === -1
        ? 0
        : (tabIndex ?? 0);
};

const useDropdownButtons = ({ children, triggerMainButtonClassName, onTriggerPressed, baseTestId }) => {
    const buttons = useMemo(() => Children.toArray(children).filter(Boolean), [children]);

    const sizerButtons = useMemo(() => (
        buttons.map((button) => {
            if (!isValidElement(button)) {
                return button;
            }

            return cloneElement(button, {
                tabIndex: -1,
                'data-testid': undefined
            });
        })
    ), [buttons]);

    const buildOnPress = useCallback((button) => {
        return (event) => {
            button.props?.onPress?.(event);
            onTriggerPressed?.(event);
        };
    }, [onTriggerPressed]);

    const triggerButtons = useMemo(() => (
        buttons.map((button) => {
            if (!isValidElement(button)) {
                return button;
            }

            return cloneElement(button, {
                className: [button.props?.className, triggerMainButtonClassName].filter(Boolean).join(' '),
                onPress: buildOnPress(button),
                tabIndex: normalizeTabIndex(button.props?.tabIndex),
                'data-testid': baseTestId ? `${baseTestId}__trigger` : undefined
            });
        })
    ), [baseTestId, buildOnPress, buttons, triggerMainButtonClassName]);

    return {
        buttons,
        sizerButtons,
        triggerButtons
    };
};

export default useDropdownButtons;
